import { Component, OnInit } from '@angular/core';
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: 'app-birthdays',
  templateUrl: './birthdays.component.html',
  styleUrls: ['./birthdays.component.scss'],
})
export class BirthdaysComponent implements OnInit {

  high_employees: any;

  anniversaries: any;

  defaultImage: string = 'assets/icon/avatar.svg';

  meses: any = {
    "01": "enero", 
    "02": "febrero", 
    "03": "marzo", 
    "04": "abril", 
    "05": "mayo", 
    "06": "junio", 
    "07": "julio", 
    "08": "agosto", 
    "09": "septiembre", 
    "10": "octubre", 
    "11": "noviembre", 
    "12": "diciembre"
  };

  dates: any = [];

  selectedTab: string;

  selectedType: string = 'all';

  constructor(private authService: AuthService) { }

  ngOnInit() {
    let CurrentDate = new Date();
    this.selectedTab = this.padTwoDigits(CurrentDate.getMonth() + 1)+"-"+this.padTwoDigits(CurrentDate.getDate());
    this.getBirthdaysAndAnniversaries(this.selectedTab);
  }

  getBirthdaysAndAnniversaries(date:string, birthdays:boolean = true, anniversaries:boolean = true){
    this.authService.getBirthdays(date,birthdays,anniversaries).subscribe((response: any) => {
      this.dates = response["dates"];
      this.high_employees = response["high_employees"];
      this.sortByFullName();
    });
  }

  sortByFullName(){
    this.high_employees.sort(function(a, b){
      if(a.full_name.toLowerCase() < b.full_name.toLowerCase()){
        return -1 ;
      }else if( a.full_name.toLowerCase() > b.full_name.toLowerCase() ){
        return 1;
      }else{
        return 0;
      }
    });
  }

  padTwoDigits(num: number) {
    return num.toString().padStart(2, "0");
  }

  getMonthLabel(date){
    return date.substring(3, 6)+" de "+this.meses[date.substring(0, 2)]
  }

  changeSelectedType(type){
    this.selectedType = type;
    if(this.selectedType == 'all'){
      this.getBirthdaysAndAnniversaries(this.selectedTab);
    }else if(this.selectedType == 'birthdays'){
      this.getBirthdaysAndAnniversaries(this.selectedTab,true,false);
    }else if(this.selectedType == 'anniversaries'){
      this.getBirthdaysAndAnniversaries(this.selectedTab,false,true);
    }
  }

  segmentChanged(ev: any) {
    this.selectedTab = ev.detail.value;
    if(this.selectedType == 'all'){
      this.getBirthdaysAndAnniversaries(this.selectedTab);
    }else if(this.selectedType == 'birthdays'){
      this.getBirthdaysAndAnniversaries(this.selectedTab,true,false);
    }else if(this.selectedType == 'anniversaries'){
      this.getBirthdaysAndAnniversaries(this.selectedTab,false,true);
    }
  }
}
